<template>
  <div class="container">
    <form class="form-top">
      <label class="checkbox-inline" v-for="item in categories">
        <input type="checkbox" v-model="search.catalog" @change="fetchList()" :value="item">{{item}}
      </label>
    </form>
    <ul class="nav nav-tabs nav-tabs-c">
      <li role="presentation" v-link="{path: '/try/normal', activeClass: 'active'}" ><a href="#">当前试走</a></li>
      <li role="presentation" v-link="{path: '/try/history', activeClass: 'active'}" ><a href="#">历史试走</a></li>
    </ul>
    <div class="row flex-row">
      <div class="col-xs-6" v-for="item in list" track-by="$index">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="clearfix">
              <div class="pull-left">
                <span class="text-danger">
                {{item.name}} [{{item.catalog}}]
                </span>
                {{item.meetPlace}}
                {{item.start}}
                {{item.meetTime}}
              </div>
            </div>
          </div>
          <table class="table table-bordered text-center" v-for="role in item.roles" track-by="$index">
            <caption class="text-center">
              <div class="pull-left">
                <button class="btn btn-xs btn-primary" type="button" @click="showLeader(item)">添</button>
                <button class="btn btn-xs btn-success" type="button" @click="showTry(role)">改</button>
                <button class="btn btn-xs btn-danger" type="button" @click="removeTry(role)">删</button>
              </div>
              {{role.role}} {{role.leaderSize}}/{{role.size}}
            </caption>
            <tbody>
              <tr v-for="leader in role.leaders" track-by="$index">
                <td>{{leader.name}}</td>
                <td>{{leader.mobile}}</td>
                <td>
                  <button type="button" class="close" @click="click(removeLeader)($event, leader)">&times;</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <aside :show.sync="isShowTry" placement="right" header="修改人数" :width="450">
      <form>
        <div class="form-group">
          <label class="control-label">修改人数</label>
          <input type="number" class="form-control" v-model="changeNumForm.size">
        </div>
        <!--
        <div class="form-group">
          <label class="control-label">发送消息</label>
          <div>
            <label class="radio-inline">
              <input type="radio" v-model="changeNumForm.messageLevel" :value="5">立即发送
            </label>
            <label class="radio-inline">
              <input type="radio" v-model="changeNumForm.messageLevel" :value="0">稍后发送
            </label>
          </div>
        </div>
        -->
        <div class="from-group text-center">
          <button class="btn btn-primary" type="button" @click="click(updateTry)($event)">修改</button>
        </div>
      </form>
    </aside>
    <aside :show.sync="isShowLeader" placement="right" :header="trip.name" :width="450">
      <form>
        <div class="form-group">
          <input type="text" class="form-control" v-model="leaderName" debounce="500" placeholder="search">
        </div>
      </form>
      <table class="table table-condensed">
        <tr v-for="item in leaders | filterBy leaderName in 'name' 'nickName'" track-by="$index">
          <td>
            <button class="btn btn-xs btn-success" type="button" @click="addLeader(trip, item)">排</button>
          </td>
          <td>
            {{item.name}}({{item.nickName}})
          </td>
          <td>
            {{item.sex}} {{item.mobile}}
          </td>
          <td>
            <a v-link="'/giver/' + item.id" @click="isShowLeader = false" class="btn-link">管理</a>
          </td>
        </tr>
      </table>
    </aside>
  </div>
</template>
<script>
  import { tabset, tab, aside, datepicker } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'

  export default {
    components: {
      tabset,
      tab,
      aside,
      datepicker
    },
    data () {
      return {
        leaderName: '',
        isShowTry: false,
        isShowLeader: false,
        categories: config.categories,
        date: new Date().toLocaleDateString(),
        list: [],
        trip: {},
        changeNumForm: {},
        changeNumTemp: {},
        leaders: [],
        search: {
          catalog: [],
          history: ''
        }
      }
    },
    methods: {
      fetchList () {
        let params = {
          catalog: this.search.catalog.join(','),
          history: this.$route.params.status === 'history' ? 'yes' : ''
        }
        return this.$http.get(`${config.apiM}/product/giver/work?test`, params)
          .then(({data}) => {
            this.list = data
          })
      },
      showTry (data) {
        this.isShowTry = true
        this.changeNumTemp = data
        this.changeNumForm = {size: data.size, messageLevel: 0}
      },
      updateTry () {
        return this.$http.put(`${config.apiM}/product/giver/demand/${this.changeNumTemp.demandId}`, this.changeNumForm)
          .then(() => {
            this.changeNumTemp.size = this.changeNumForm.size
            this.isShowTry = false
          })
      },
      removeTry (role) {
        if (!window.confirm('确认取消？')) {
          return Promise.reject()
        }
        return this.$http.delete(`${config.apiM}/product/giver/demand/${role.demandId}`)
          .then(() => {
            this.fetchList()
          })
      },
      removeLeader (item) {
        if (window.confirm('确认删除？')) {
          return this.$http.delete(`${config.apiM}/product/giver/work/${item.workId}`)
            .then(() => {
              this.fetchList()
            })
        }
        return Promise.reject()
      },
      addLeader (trip, leader) {
        let postData = {
          leaderId: leader.id,
          role: '试走',
          tripId: trip.tripId
        }

        return this.$http.post(`${config.apiM}/product/giver/work`, postData)
          .then(({data}) => {
            this.fetchList()
          })
      },
      showLeader (trip) {
        this.isShowLeader = true
        this.trip = trip
        if (!this.leaders.length) {
          this.$http.get(config.api + '/giver/leader')
            .then(function ({data}) {
              this.leaders = data
            })
        }
      },
      click: utils.click
    },
    route: {
      data ({next}) {
        this.fetchList()
        next()
      }
    }
  }
</script>
<style scoped>
  .nav-tabs-c {
    margin-bottom: 20px;
  }
  .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  .form-top {
    margin-bottom: 20px;
  }
</style>



/** WEBPACK FOOTER **
 ** Try.vue?5cd9767e
 **/